import React, {useState, useRef, useEffect, useContext} from "react";
import {useHistory} from "react-router-dom";
import styles from "./variantExplorer/VariantExplorer.module.scss"
import appContext from "../../../../context/appContext";
import HelpInfoBox from "../../../Componnets/HelpInfoBox/HelpInfoBox";
import http from "../../../../services/api/utilities/http";

const layerInitValue = {
    variants: [1],
    active_variants: [1]
}

const VariantExplorer = props => {

    const context = useContext(appContext);
    const el = useRef();
    const [canDragBottomHandler, setCanDragBottomHandler] = useState(true);
    const [canDragTopHandler, setCanDragTopHandler] = useState(true);
    const [isDragging, setIsDragging] = useState(null);
    const [whatDirectionIsMoving, setWhatDirectionIsMoving] = useState(null);
    const [topHandlerDirection, setTopHandlerDirection] = useState(-15);
    const [bottomHandlerDirection, setBottomDirectionHandler] = useState(26);
    const [topDirectionY, setTopDirectionY] = useState(-15);
    const [bottomDirectionY, setBottomDirectionY] = useState(26);
    const [stepShowMore, setStepShowMore] = useState(null);
    const [marginBetween, setMarginBetween] = useState(24);
    const [sliderHeight, setSliderHeight] = useState(35);
    const [positionStyle, setPositionStyle] = useState({top: 5});
    const [data, setData] = useState([]);
    const [result, setResult] = useState([]);
    const [dataToShow, setDataToShow] = useState([]);
    const [activeId, setActiveId] = useState(1);
    const [listOfSelectedVariants, setListOfSelectedVariants] = useState([]);
    const [listOfSingleSelectedVariants, setListOfSingleSelectedVariants] = useState([]);
    const [marginStep, setMarginStep] = useState(35);
    const [allRemainingVariants, setAllRemainingVariants] = useState(null);
    const [isAllRemainingActive, setIsAllRemainingActive] = useState(false);
    const [multipleSelect, setMultipleSelect] = useState(false);
    const [calcDataToShow, setCalcDataToShow] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(true);
    const history = useHistory();

    useEffect(() => {
        if (!activeId) {
            setActiveId(1)
        }
    }, [activeId])

    useEffect(() => {
        if (history.location.search === "?view=side-by-side") {
            setIsMenuOpen(false);
        }
    }, [history]);

    let savedVariants = context.handleAutoSave().processMapVariants;
    if (history.location.pathname === '/process-compare') {
        if (props.isSecondaryVariantExplorer && !props.isVariantExplorerLinked) {
            savedVariants = context?.handleLayerList()?.length && context?.handleLayerList()?.find(item => item.selected)?.appliedFilters?.variants
        } else {
            savedVariants = context?.handleLayerList()?.find(item => item.type === "mainLayer")?.appliedFilters?.variants
        }
    } else if (history.location.pathname === "/generate-bpmn-model") {
        savedVariants = context.handleSaveGenerateBpmnFilters().variants;
    }

    // useEffect(()=>{
    //     props.setVariantIndex(savedVariants,false)
    // },[])

    useEffect(() => {
        if (!savedVariants) {
            savedVariants = [1]
        }
        if (data && data.length > 0 && savedVariants && savedVariants.length > 0) {
            const selected = data.filter(item => savedVariants.find(i => i === item.id));
            setListOfSelectedVariants(selected);
            setCalcDataToShow(true)
            // setCalcDataToShow(true);
        }
    }, [savedVariants, data]);

    const isChangeVariantsFilters = context.handleChangeVariantsFilter();
    useEffect(() => {
        if (isChangeVariantsFilters.length > 0 && listOfSelectedVariants.length > 0) {
            setCalcDataToShow(true);
            const selectedVariants = dataToShow.filter(item => isChangeVariantsFilters.find(i => item.id === i));
            context.handleChangeVariantsFilter([]);
            if (selectedVariants[0]) {
                setActiveId(selectedVariants[0].id);
            }
        }
    }, [isChangeVariantsFilters]);

    useEffect(() => {
        if (savedVariants && savedVariants.length > 0) {
            setActiveId(savedVariants[0]);
        } else {
            setActiveId(1);
        }
    }, [savedVariants]);

    const getVariantsData = () => {
        let uid = null;
        if (context.handleUid().uid) {
            uid = context.handleUid().uid;
        } else {
            uid = JSON.parse(localStorage.getItem("mapData")).uid;
        }
        http.get('process_mining/process_discovery/' + uid)
            .then(res => {
                let response = res.data.data
                let {variants, events, case_count} = response
                setData(variants);
                context.handleEvents_cases({events, cases: case_count})
                context.handleListOfVariants(res.data.data.variants);
                setCalcDataToShow(true);
            })
            .catch(err => {
                console.log(err.response)
            })
    }

    useEffect(() => {
        getVariantsData()
    }, []);

    useEffect(() => {
        if (listOfSelectedVariants.length > 0 && !isDragging) {
            const listOfSelectedVariantsIds = listOfSelectedVariants.map(item => item.id)
            if (props.isVariantExplorerLinked && listOfSelectedVariants && !listOfSelectedVariantsIds.includes(activeId)) {
                setActiveId(listOfSelectedVariants[listOfSelectedVariants.length - 1]?.id)
                setIsAllRemainingActive(false)
            }
            // ===============================================================================================
            // ===============================================================================================
            // ===============================================================================================
            // ===============================================================================================
            // HESSAN GET THE API HERE INSTEAD OF 3 OTHER PLACES
            // console.log('variants: ', listOfSelectedVariants);
        }
    }, [listOfSelectedVariants, isDragging]);

     const chunkArray = (myArray, chunk_size) => {
        let index = 0;
        const arrayLength = myArray.length;
        const tempArray = [];

        for (index = 0; index < arrayLength; index += chunk_size) {
            let myChunk = myArray.slice(index, index+chunk_size);
            tempArray.push(myChunk);
        }

        return tempArray;
    }

    useEffect(() => {
        if (isDragging) {
            let filteredData = listOfSingleSelectedVariants.filter(item => item.id !== activeId);
            if (whatDirectionIsMoving === 'up') {
                filteredData = filteredData.filter(item => item.id !== activeId + 1);
            } else {
                filteredData = filteredData.filter(item => item.id !== activeId - 1);
            }
            setListOfSingleSelectedVariants(filteredData);
        }
    }, [activeId]);

    useEffect(() => {
        if (isDragging && bottomDirectionY > (topDirectionY + marginStep)) {
            if (topDirectionY > 0) {
                if (topDirectionY >= activeId * marginStep) {
                    setSliderHeight(sliderHeight - marginStep);
                    const selected = listOfSelectedVariants.filter(item => item.id !== (activeId));
                    setListOfSelectedVariants([...selected]);
                    setActiveId(activeId + 1);
                } else if (topDirectionY < (activeId - 1) * marginStep) {
                    setSliderHeight((bottomDirectionY + 6) - ((activeId - 2) * marginStep));
                    const selected = dataToShow.filter(item => item.id === (activeId - 1));
                    if (!listOfSelectedVariants.some(item => item.id === (activeId - 1))) {
                        setListOfSelectedVariants([...selected, ...listOfSelectedVariants]);
                    }
                    setActiveId(activeId - 1);
                }
            }
            setTopHandlerDirection(el.current.offsetTop - 20);
        }
    }, [topDirectionY]);

     useEffect(() => {
         if (isDragging && bottomDirectionY >= (topDirectionY + marginStep) && bottomDirectionY <= 400) {
             if (bottomDirectionY >= (activeId + 0.05) * marginStep) {
                 const calculatedHeight = ((activeId + 1) * marginStep) - (topDirectionY + 16);
                 setSliderHeight(calculatedHeight);
                 const selected = dataToShow.filter(item => item.id === (activeId + 1));
                 if (!listOfSelectedVariants.some(item => item.id === (activeId + 1))) {
                     if (selected.length !== 0) {
                         setListOfSelectedVariants([...listOfSelectedVariants, ...selected]);
                     } else {
                         setListOfSelectedVariants([...listOfSelectedVariants, ...allRemainingVariants]);
                         setIsAllRemainingActive(true);
                     }
                 }
                 if (dataToShow[activeId]) {
                     setActiveId(activeId + 1);
                 }
             } else if ((bottomDirectionY < (activeId - 1) * marginStep) && sliderHeight > (marginStep * 2)) {
                 setSliderHeight(sliderHeight - marginStep);
                 let selected = [];
                 if (isAllRemainingActive) {
                     const ids = allRemainingVariants.map(item => item.id);
                     selected = listOfSelectedVariants.filter(item => !ids.includes(item.id));
                     setIsAllRemainingActive(false);
                 } else {
                     selected = listOfSelectedVariants.filter(item => item.id !== (activeId));
                     setActiveId(activeId - 1);
                 }
                 setListOfSelectedVariants([...selected]);
             }
             setBottomDirectionHandler((el.current.offsetTop + el.current.clientHeight) - 13);
         }
     }, [bottomDirectionY]);

    useEffect(() => {
        let step = 0;
        let res = [];
        if (result.length > 0 && calcDataToShow) {
            if (listOfSelectedVariants.some(item => item.id >=26)) {
                setIsAllRemainingActive(true);
            }
            if (listOfSelectedVariants.some(item => item.id >= 21 && item.id <=25)) {
                step = 4;
                res = [...result[0], ...result[1], ...result[2], ...result[3], ...result[4]];
            } else if (listOfSelectedVariants.some(item => item.id >= 16 && item.id <=20)) {
                step = 3;
                res = [...result[0], ...result[1], ...result[2], ...result[3]];
            } else if (listOfSelectedVariants.some(item => item.id >= 11 && item.id <=15)) {
                step = 2;
                res = [...result[0], ...result[1], ...result[2]];
            } else {
                step = 1;
                if (result[1] && result[1].length) {
                    res = [...result[0], ...result[1]];
                } else {
                    res = [...result[0]];
                }

            }
            setCalcDataToShow(false);
            setDataToShow(res);
            setStepShowMore(step);
        }
    }, [calcDataToShow]);

    const calculateHeightOfSliderFromSavedData = (marginStepSize) => {
        const sortedArr = listOfSelectedVariants.sort((a, b) => {if (a.id > b.id) { return 1 } return -1});
        let sequenceNums = [];
        for (let i = 1; i < sortedArr.length; i++) {
            if (sortedArr[i].id - sortedArr[i - 1].id === 1) {
                if (sequenceNums.length === 0) {
                    sequenceNums.push(sortedArr[i - 1]);
                }
                if (sequenceNums.length > 0 && sortedArr[i].id - sequenceNums[sequenceNums.length - 1].id === 1) {
                    sequenceNums.push(sortedArr[i])
                }
            }
        }
        const singleSelectedVariants = listOfSelectedVariants.filter(item => !sequenceNums.find(i => i.id === item.id));
        setListOfSingleSelectedVariants(singleSelectedVariants);
        if (sequenceNums.length > 0) {
            setPositionStyle({top: (sequenceNums[0].id - 1) * marginStepSize + 6});
            setTopDirectionY(((sequenceNums[0].id - 1) * marginStepSize) - 14);
            setTopHandlerDirection(((sequenceNums[0].id - 1) * marginStepSize) - 14);
            //setActiveId(sequenceNums[0].id);
            if (sequenceNums[sequenceNums.length - 1].id > 25) {
                setBottomDirectionY(26 * marginStepSize - 10);
                setBottomDirectionHandler(26 * marginStepSize - 10);
                setSliderHeight((25 * marginStepSize) - (((sequenceNums[0].id - 1) * marginStepSize - marginStepSize + 2)));
            } else {
                setBottomDirectionY(sequenceNums[sequenceNums.length - 1].id * marginStepSize - 10);
                setBottomDirectionHandler(sequenceNums[sequenceNums.length - 1].id * marginStepSize - 10);
                setSliderHeight(((sequenceNums[sequenceNums.length - 1].id - 1) * marginStepSize) - (((sequenceNums[0].id - 1) * marginStepSize - marginStepSize + 2)));
            }
        } else {
            setSliderHeight(33);
            setPositionStyle({top: (sortedArr[sortedArr.length - 1].id - 1) * marginStepSize + 5});
            setTopDirectionY(((sortedArr[sortedArr.length - 1].id - 1) * marginStepSize) - 14);
            setTopHandlerDirection(((sortedArr[sortedArr.length - 1].id - 1) * marginStepSize) - 14);
            setBottomDirectionY(sortedArr[sortedArr.length - 1].id * marginStepSize - 12);
            setBottomDirectionHandler(sortedArr[sortedArr.length - 1].id * marginStepSize - 12);
            setActiveId(sortedArr[sortedArr.length - 1].id);
        }
    }

    useEffect(() => {
        if (!isDragging) {
            if (dataToShow.length <= 10) {
                setMarginBetween(23);
                setMarginStep(35.2);
                if (listOfSelectedVariants.length === 0) {
                    setSliderHeight(35);
                    setBottomDirectionY(27);
                    setBottomDirectionHandler(27);
                } else {
                    calculateHeightOfSliderFromSavedData(35.2);
                }
            } else if (dataToShow.length <=15) {
                setMarginBetween(11.5);
                setMarginStep(24.28);
                setPositionStyle({top: 5});
                if (listOfSelectedVariants.length === 0) {
                    setSliderHeight(34);
                    setBottomDirectionY(25);
                    setBottomDirectionHandler(25);
                } else {
                    calculateHeightOfSliderFromSavedData(24.28);
                }
            } else if (dataToShow.length <=20) {
                setMarginBetween(5.6);
                setMarginStep(18.45);
                setPositionStyle({top: 5})
                if (listOfSelectedVariants.length === 0) {
                    setSliderHeight(32);
                    setBottomDirectionY(22);
                    setBottomDirectionHandler(22);
                } else {
                    calculateHeightOfSliderFromSavedData(18.45);
                }
            } else if (dataToShow.length <= 25) {
                setMarginBetween(2.1);
                setMarginStep(15);
                setPositionStyle({top: 5})
                if (listOfSelectedVariants.length === 0) {
                    setSliderHeight(30);
                    setBottomDirectionY(19);
                    setBottomDirectionHandler(19);
                } else {
                    calculateHeightOfSliderFromSavedData(15);
                }
            } else if (dataToShow.length <= 30) {
                setMarginBetween(0);
                setMarginStep(7);
                if (listOfSelectedVariants.length === 0) {
                    setSliderHeight(15);
                } else {
                    calculateHeightOfSliderFromSavedData(7);
                }
            }
        }
    }, [dataToShow]);

    useEffect(() => {
        if (data.length > 0) {
            setResult(chunkArray(data,5));
        }
        if (data.length > 0 && savedVariants && savedVariants.length === 0) {
            setListOfSelectedVariants([data[0]]);
        }
    }, [data]);

    const handleResetVariantsSelection = () => {
        if (activeId !== 1 || listOfSelectedVariants.length > 1) {
            setListOfSelectedVariants([dataToShow[0]]);
            setListOfSingleSelectedVariants([]);
            setActiveId(1);
            setTopDirectionY(-14);
            setTopHandlerDirection(-14);
            setBottomDirectionY(25);
            setBottomDirectionHandler(25);
            setPositionStyle({top: 7});
            setSliderHeight(35)
            handleClickOnVariant(1)
        }
    }

    const handleShowMoreVariants = () => {
        setIsAllRemainingActive(false);
        handleResetVariantsSelection();
        if ((stepShowMore + 1) <= result.length) {
            if (result[stepShowMore + 1]) {
                setDataToShow([...dataToShow, ...result[stepShowMore + 1]]);
            }
        }
        setStepShowMore(stepShowMore + 1);
    }

    const handleShowLessVariants = () => {
        setIsAllRemainingActive(false);
        handleResetVariantsSelection();
        const ids = result[stepShowMore].map(item => item.id);
        const res = dataToShow.filter(item => !ids.includes(item.id));
        setDataToShow([...res]);
        setStepShowMore(stepShowMore - 1);
    }

    useEffect(() => {
        const idsArr = dataToShow.map(item => item.id);
        setAllRemainingVariants(data.filter(item => !idsArr.includes(item.id)));
    },[dataToShow]);

    const handleMouseUp = () => {
        window.removeEventListener('mousemove', handleMouseMove);
        window.removeEventListener('mouseup', handleMouseUp);
        setMultipleSelect(false);
        setIsDragging(false);
    }

    useEffect(() => {
        if (!isDragging) {
            if (whatDirectionIsMoving === 'down') {
                setBottomDirectionY((el.current.offsetTop + el.current.clientHeight) - 13);
                setBottomDirectionHandler((el.current.offsetTop + el.current.clientHeight) - 13);
            } else if (whatDirectionIsMoving === 'up') {
                setTopDirectionY(el.current.offsetTop - 20);
                setTopHandlerDirection(el.current.offsetTop - 20);
            }
        }
    }, [isDragging]);

    const handleMouseMove = ({ pageY }) => {
        if (!isDragging) {
            return;
        }
        if (whatDirectionIsMoving === 'up') {
            setTopDirectionY(pageY - 220);
        } else if (whatDirectionIsMoving === 'down') {
            setBottomDirectionY(pageY - 220);
        }
    }

    const handleClickOnSlideUp = () => {
        setPositionStyle({bottom: 390 - (bottomDirectionY + 12)});
        const selectedSequence = listOfSelectedVariants.filter(item => !listOfSingleSelectedVariants.find(i => i.id === item.id));
        const sortedArr = selectedSequence.sort((a, b) => {if (a.id > b.id) { return 1 } return -1});
        if (!multipleSelect && sortedArr[0]) {
            setActiveId(sortedArr[0].id);
        }
        setIsDragging(true);
        setWhatDirectionIsMoving('up');
    }

    const handleClickOnSlideDown = () => {
        setPositionStyle({top: topDirectionY + 20});
        const selectedSequence = listOfSelectedVariants.filter(item => !listOfSingleSelectedVariants.find(i => i.id === item.id));
        let sortedArr = listOfSelectedVariants;
        if (selectedSequence.length > 1) {
            sortedArr = selectedSequence.sort((a, b) => {if (a.id > b.id) { return 1 } return -1});
        }
        if (!isAllRemainingActive) {
            if (!multipleSelect) {
                setActiveId(sortedArr[sortedArr.length - 1].id);
            }
        } else {
            if (!multipleSelect) {
                setActiveId(sortedArr.reverse().find(item => item.id <= dataToShow.length).id);
            }
        }
        setIsDragging(true);
        setWhatDirectionIsMoving('down');
    }

    useEffect(() => {
        if (props.isVariantExplorerLinked) {
            const mainLayerVariants = context.handleLayerList()?.find(item => item.type === "mainLayer")?.appliedFilters?.variants
            const activeFilters = {
                variants: mainLayerVariants || [1],
                active_variants: mainLayerVariants?.map(item => 1) || [1]
            }
            handleAddVariantsToCurrentSecondLayerFilters(activeFilters, false)
        }
    }, [props.isVariantExplorerLinked])

    const handleAddVariantsToCurrentSecondLayerFilters = (activeFilters, isSecondaryVariantExplorer) => {
        const filterListArray = context?.handleLayerList()?.length ? [...context?.handleLayerList()] : []
        let findIndex = null

        if (isSecondaryVariantExplorer) {
            findIndex = filterListArray?.findIndex(item => item.selected && item.type !== "mainLayer")
        } else {
            findIndex = filterListArray?.findIndex(item => item.type === "mainLayer")
        }

        if (props.isVariantExplorerLinked) {
            const mainLayerIndex = filterListArray?.findIndex(item => item.type === "mainLayer")
            const secondLayerIndex = filterListArray?.findIndex(item => item.selected && item.type !== "mainLayer")
            filterListArray.splice(mainLayerIndex, 1, {
                ...filterListArray[mainLayerIndex],
                appliedFilters: {
                    ...filterListArray[mainLayerIndex]?.appliedFilters,
                    ...activeFilters
                },
                temporaryAppliedFilters: {
                    ...filterListArray[mainLayerIndex]?.appliedFilters,
                    ...activeFilters
                },
            })
            filterListArray.splice(secondLayerIndex, 1, {
                ...filterListArray[secondLayerIndex],
                appliedFilters: {
                    ...filterListArray[secondLayerIndex]?.appliedFilters,
                    ...activeFilters
                },
                temporaryAppliedFilters: {
                    ...filterListArray[secondLayerIndex]?.appliedFilters,
                    ...activeFilters
                },
            })
        } else {
            filterListArray.splice(findIndex, 1, {
                ...filterListArray[findIndex],
                appliedFilters: {
                    ...filterListArray[findIndex]?.appliedFilters,
                    ...activeFilters
                },
                temporaryAppliedFilters: {
                    ...filterListArray[findIndex]?.appliedFilters,
                    ...activeFilters
                },
            })
        }
        context.handleLayerList(filterListArray)

        if (history.location.search !== "?view=side-by-side") {
            let passedList = []
            if (props.isVariantExplorerLinked) {
                passedList = activeFilters.variants
            } else {
                passedList = data.filter(i => context?.handleLayerList()?.length && context.handleLayerList().find(item => item.type === "mainLayer")?.appliedFilters)
            }
            props.setVariantIndex(passedList)
        }
    }

    useEffect(() => {
        if (isDragging) {
            window.addEventListener('mousemove', handleMouseMove);
            window.addEventListener('mouseup', handleMouseUp);
        } else if (isDragging !== null) {
            // Pass Data to Hessan
            const activeFilters = {
                variants: listOfSelectedVariants.map(item => item.id),
                active_variants: listOfSelectedVariants.map(item => 1)
            }
            if (history.location.pathname === "/process-compare") {
                handleAddVariantsToCurrentSecondLayerFilters(activeFilters, props.isSecondaryVariantExplorer)
            } else {
                props.setVariantIndex(listOfSelectedVariants)
            }
        }
    }, [isDragging]);

    useEffect(() => {
        if (!context.handleIsFiltersModalOpen() && context.handleLayerList().length && !props.isSecondaryVariantExplorer && (history.location.pathname === "/process-compare")) {
            if (props.isVariantExplorerLinked && !context.handleLayerList()?.find(item => item.type === "mainLayer")?.appliedFilters) return
            const currentMainLayerFilters = context.handleLayerList()?.find(item => item.type === "mainLayer")?.appliedFilters
            const secondLayerFilters = context.handleLayerList()?.find(item => item.selected && (!item.type || item.type === "layer"))?.appliedFilters
           // if(layers.currentMainLayerFilters !== secondLayerFilters &&)
           //   setLayers({currentMainLayerFilters,secondLayerFilters})
            // pass data to hessan for api call
            context.selectFilter({
                "layer1_filters": currentMainLayerFilters || {
                    variants: [1],
                    active_variants: [1]
                },
                "layer2_filters": secondLayerFilters  || {
                    variants: [1],
                    active_variants: [1]
                },
            })
            context.actionFilter("fetching")
        }
    }, [context.handleLayerList()])

   // && history.location.search !== "?view=side-by-side"
    useEffect(() => {
        if (!isDragging && !canDragBottomHandler) {
            setTimeout(() => {
                setCanDragBottomHandler(true);
            }, 400);
        }
        if (!isDragging && !canDragTopHandler) {
            setTimeout(() => {
                setCanDragTopHandler(true);
            }, 400);
        }
    }, [isDragging, canDragBottomHandler]);

    useEffect(() => {
        if (topDirectionY < -20) {
            setTopDirectionY(-14);
            setTopHandlerDirection(-14);
            setCanDragTopHandler(false);
        }
        if (topDirectionY > 5 && topDirectionY < 375) {
            setCanDragTopHandler(true);
        }
        if (bottomDirectionY > 390) {
            setBottomDirectionY(375);
            setBottomDirectionHandler(375);
            setCanDragBottomHandler(false);
        }
        if (bottomDirectionY < 360 && bottomDirectionY > 6) {
            setCanDragBottomHandler(true);
        }
    }, [topDirectionY, bottomDirectionY]);

    const handleClickOnVariant = (id) => {
        let list = [];
        let activeId = null;
        const item = dataToShow.find(i => i.id === id);
        const isAddedBefore = listOfSelectedVariants.some(item => item.id === id);
        if (sliderHeight > marginStep || isAllRemainingActive) {
            list = [item];
            setIsAllRemainingActive(false);
            activeId = id;
        } else {
            if (isAddedBefore) {
                const filteredData = listOfSelectedVariants.filter(item => item.id !== id);
                if (filteredData.length !== 0) {
                    list = [...filteredData];
                } else {
                    list = [...listOfSelectedVariants]
                }
                activeId = list[list.length - 1].id
            } else {
                list = [...listOfSelectedVariants, item];
                setMultipleSelect(true);
            }
        }
        setListOfSelectedVariants(list);
        setListOfSingleSelectedVariants(list);
        // Pass Data to Hessan ================
        const activeFilters = {
            variants: list.map(item => item.id),
            active_variants: list.map(item => 1),
        }

        if (history.location.pathname === "/process-compare") {
            handleAddVariantsToCurrentSecondLayerFilters(activeFilters, props.isSecondaryVariantExplorer)
        } else {
            props.setVariantIndex(list)
        }

        // ====================================
        if (!isAddedBefore)  {
            activeId = id;
        }
        setActiveId(activeId)
        setSliderHeight(marginStep);
        setTopDirectionY(((activeId - 1) * marginStep) - 15);
        setTopHandlerDirection(((activeId - 1) * marginStep) - 15);
        setBottomDirectionY((activeId * marginStep) - 10);
        setBottomDirectionHandler((activeId * marginStep) - 10);
        setPositionStyle({top: ((activeId - 1) * marginStep) + 4});
    }

    const handleClickShowRemainVariants = () => {
        setListOfSelectedVariants(allRemainingVariants);
        setActiveId(null);
        setSliderHeight(0);
        setBottomDirectionY(-999999);
        setBottomDirectionHandler(-999999);
        setTopDirectionY(-999999);
        setTopHandlerDirection(-999999);
        setIsAllRemainingActive(true);
        setListOfSingleSelectedVariants([]);
        setListOfSelectedVariants([]);
        // Pass Data to Hessan ================
        const activeFilters = {
            variants: allRemainingVariants.map(item => item.id),
            active_variants: allRemainingVariants.map(item => 1),
        }

        if (history.location.pathname === "/process-compare") {
            handleAddVariantsToCurrentSecondLayerFilters(activeFilters, props.isSecondaryVariantExplorer)
        } else {
            props.setVariantIndex(allRemainingVariants)
        }

        // ====================================
    }

    const listOfItems = dataToShow.map((item) => {
        const selected = listOfSelectedVariants.some(v => v.id === item.id);
        const singleSelected = listOfSingleSelectedVariants.some(v => v.id === item.id);
        return (
            <li key={`${item.id}_${item.percentage}`} onClick={() => handleClickOnVariant(item.id)} style={{marginBottom: marginBetween}}>
                {
                    isMenuOpen ? (
                        <span className={activeId === item.id ? styles.isActive : '' + ' ' + (selected ? styles.selected : '')}>
                            {item.percentage}% | {item.count}
                        </span>
                    ) : null
                }
                <div
                  data-value={item.percentage}
                  style={{backgroundColor: (selected && activeId !== item.id && singleSelected) && props.sliderColor}}
                  className={
                    [
                        (activeId === item.id ? styles.isActive : ''),
                        (singleSelected ? styles.singleSelected : ''),
                        styles.bullet,
                        (selected ? styles.selected : '')
                    ]
                        .join(' ')}>
                    <span>{item.id}</span>
                </div>
            </li>
        )
    })

    const pathName = history.location.pathname

    return (
      <div className={[styles.VariantExplorerContainer, isMenuOpen && styles.menuOpen].join(" ")}>
        { isMenuOpen && <div className={[styles.caseCoverageText, (history.location.search === "?view=side-by-side") && styles.sideBySideView, (history.location.pathname === "/variant-explorer" || history.location.pathname === "/generate-bpmn-model") && styles.variantExplorerView].join(' ')}>Coverage | Frequency</div> }
        <div
          id="variant-explorer"
          className={[styles.VariantExplorer, pathName === "/process-compare" && styles.processCompareVariantExplorer].join(" ")}
          style={{marginTop: history.location.search === "?view=side-by-side" && 32, marginRight: history.location.search === "?view=side-by-side" && -16}}
        >
            <div className={styles.menu}>
                {
                    pathName !== "/process-explorer" &&
                    <svg onClick={() => !isMenuOpen ? setIsMenuOpen(true) : setIsMenuOpen(false)}
                         className={(isMenuOpen ? styles.isOpen : '')} width="30" height="30" viewBox="0 0 30 30"
                         fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="15" cy="15" r="14.5" fill="white" stroke="#0A195C"/>
                        <path d="M13.3333 19.6667L8.66665 15L13.3333 10.3334" stroke="#0A195C" stroke-width="1.5"
                              stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M19.3333 19.6667L14.6666 15L19.3333 10.3334" stroke="#0A195C" stroke-width="1.5"
                              stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                }

                <div className={styles.tabs + ' ' + (isMenuOpen ? styles.showMenu : '')}>

                </div>
            </div>
            {
                canDragTopHandler &&
                    <span onMouseDown={handleClickOnSlideUp} onMouseUp={handleMouseUp} className={styles.slideUp} style={{top: topHandlerDirection}}>
                        <svg width="20" height="6" viewBox="0 0 20 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19 5C15.9302 2.73613 8.03256 -0.433289 1 5" stroke={props.sliderColor || "#6900CC"} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
            }
            <div ref={el} style={positionStyle} className={styles.sliderContainer}>
                <span style={{height: sliderHeight, backgroundColor: props.sliderColor}} className={styles.slider}></span>
            </div>
            {
                canDragBottomHandler &&
                    <span onMouseDown={handleClickOnSlideDown} onMouseUp={handleMouseUp} className={styles.slideDown} style={{top: bottomHandlerDirection}}>
                        <svg width="20" height="6" viewBox="0 0 20 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19 1C15.9302 3.26387 8.03256 6.43329 1 1" stroke={props.sliderColor || "#6900CC"} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
            }
            <ul>
                {listOfItems}
                <li onClick={handleClickShowRemainVariants} style={{marginBottom: 40}}>
                    {isMenuOpen ? (<span
                        className={isAllRemainingActive ? styles.isActive : '' + ' ' + (isAllRemainingActive ? styles.selected : '')}>
                        All Remain Variants
                    </span>) : null}
                    <div data-value={"All"} className={(isAllRemainingActive ? styles.isActive : '') + ' ' + styles.bullet + ' ' + (isAllRemainingActive ? styles.selected : '')}>
                        <span></span>
                    </div>
                </li>
                {
                    isMenuOpen ? (
                        <>
                            {result[stepShowMore + 1] && stepShowMore + 1 < 5 && <li>
                                <span onClick={handleShowMoreVariants} className={styles.moreVariants} style={{color: props.sliderColor}}>
                                    More Variants...
                                </span>
                                        </li>}
                                        {(stepShowMore + 1 > 2 && stepShowMore < 5) && <li>
                                <span onClick={handleShowLessVariants} className={styles.lessVariants} style={{color: props.sliderColor}}>
                                    Less Variants...
                                </span>
                            </li>}
                        </>
                    ) : null
                }

            </ul>
            {
                history.location && history.location.pathname !== "/process-compare" &&
                    <span className={styles.title}>Variant Explorer</span>
            }

            {
                history.location && history.location.pathname === "/process-compare" && (!localStorage.getItem("meetAnalysis") || !JSON.parse(localStorage.getItem("meetAnalysis")).includes(context.handleUid().id)) &&
                <div className={styles.helpInfoBox}>
                    <HelpInfoBox direction={'left'}>
                        <p>
                            Variant / Process Explorer just affects the <span>main layer</span> and <span>current analysis.</span> In case
                            you wanted to change other layer's Variant please use "Go to Analysis" option in Layer Panel.
                        </p>
                    </HelpInfoBox>
                </div>
            }
        </div>
      </div>
    )
};

export default VariantExplorer;
